export var linkClickOpensInNewTab = function linkClickOpensInNewTab(evt) {
  var target = evt.currentTarget.getAttribute('target') || '_self';
  var modifier = [evt.shiftKey, evt.ctrlKey, evt.metaKey].some(function (k) {
    return k === true;
  });
  return target !== '_self' || modifier;
};